import { CheckCircleFilled, QuestionCircleTwoTone } from "@ant-design/icons";
import { Popover, Button, Divider } from "antd";
import { onValue, ref, remove, set } from "firebase/database";
import { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { db } from "../utils/firebase";
import { MyContext } from "../utils/utils";
import styles from "./card.module.css";

const Card = ({
  name,
  distance = null,
  color,
  fontColor = null,
  state = null,
  select,
  index = null,
  setSelectIdx = null,
  mode,
}) => {
  const { key } = useParams();
  const { currentUser } = useContext(MyContext);

  const selectBtn = () => {
    if (select != null) {
      setSelectIdx(null);
      const currentCardRef = ref(db, "rooms/" + key + "/currentCard");
      onValue(
        currentCardRef,
        (snapshot) => {
          const currentCard = snapshot.val();
          if (currentCard.color == "#000000" || currentCard.name == "색바꾸기")
            return;
          var cardKey = currentCard.name;
          if (cardKey == "") {
            cardKey = "empty";
          }
          cardKey = cardKey.replace("/", "");
          const usedCardRef = ref(db, "rooms/" + key + "/usedCard/" + cardKey);
          set(usedCardRef, currentCard);
        },
        {
          onlyOnce: true,
        }
      );
      set(ref(db, "rooms/" + key + "/currentCard"), {
        color: color,
        distance: distance,
        name: name,
        fontColor: fontColor,
      });

      const cardsRef = ref(
        db,
        "rooms/" + key + "/joiner/" + currentUser.uid + "/cards"
      );
      onValue(
        cardsRef,
        (snapshot) => {
          const val = snapshot.val();
          set(
            cardsRef,
            val.filter((value, idx) => idx != index)
          );
        },
        {
          onlyOnce: true,
        }
      );

      if ((color == "#000000" || name == "색바꾸기") && name != "빅3") {
        specialCards();
      } else {
        if (mode.turn) {
          set(ref(db, "rooms/" + key + "/selecting"), true);
        } else {
          set(ref(db, "rooms/" + key + "/selecting"), false);
          nextDirection();
        }
      }
    }
  };

  const specialCards = () => {
    if (name == "방향전환") {
      changeDirection();
      nextDirection();
      set(ref(db, "rooms/" + key + "/selecting"), false);
    } else if (name == "점프") {
      nextDirection();
      set(ref(db, "rooms/" + key + "/selecting"), false);
    } else if (name == "반사") {
      changeDirection();
      const myRef = ref(db, "rooms/" + key + "/previousJoiner");
      onValue(
        myRef,
        (snapshot) => {
          set(ref(db, "rooms/" + key + "/currentJoiner"), snapshot.val());
          set(myRef, currentUser.uid);
        },
        { onlyOnce: true }
      );
      set(ref(db, "rooms/" + key + "/selecting"), false);
    } else if (name == "색바꾸기" && color != "#000000") {
      set(ref(db, "rooms/" + key + "/selecting"), false);
      nextDirection();
    }
  };

  const changeDirection = async () => {
    const directionRef = ref(db, "rooms/" + key + "/direction");
    await onValue(
      directionRef,
      (snapshot) => {
        const direction = snapshot.val();
        var temp = "CCW";
        if (direction == "CCW") {
          temp = "CW";
        }
        set(directionRef, temp);
      },
      {
        onlyOnce: true,
      }
    );
  };

  const nextDirection = () => {
    onValue(
      ref(db, "rooms/" + key + "/joiner"),
      (snapshot) => {
        const joiners = Object.keys(snapshot.val());
        const currentIdx = joiners.indexOf(currentUser.uid);
        var nextIdx;
        onValue(
          ref(db, "rooms/" + key + "/direction"),
          (snapshot) => {
            const direction = snapshot.val();
            console.log(direction);
            if (direction == "CCW") {
              nextIdx = currentIdx + 1;
              if (nextIdx >= joiners.length) {
                nextIdx = 0;
              }
            } else if (direction == "CW") {
              nextIdx = currentIdx - 1;
              if (nextIdx < 0) {
                nextIdx = joiners.length - 1;
              }
            }
            console.log(joiners, currentIdx, nextIdx);
            set(ref(db, "rooms/" + key + "/selecting"), false);
            set(ref(db, "rooms/" + key + "/currentJoiner"), joiners[nextIdx]);
          },
          {
            onlyOnce: true,
          }
        );
      },
      {
        onlyOnce: true,
      }
    );
  };

  const [hover, setHover] = useState(false);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);

  useEffect(() => {
    var val = null;
    var temp = null;

    switch (name) {
      case "반사":
        val = "방금 받은 질문을 질문자에게 돌려줍니다 (진행방향도 바뀝니다)";
        break;
      case "점프":
        val = "방금 받은 질문을 진행방향의 다음 사람에게 넘겨줍니다";
        break;
      case "빅3":
        val = "방금 받은 질문을 본인 포함 선택한 3명이 함께 대답합니다";
        break;
      case "재활용":
        val =
          "내려놓은 카드더미에서 원하는 카드를 선택해 원하는 사람에게 질문합니다";
        break;
      case "방향전환":
        val = "진행 방향을 반대로 바꿉니다";
        break;
      case "색바꾸기":
        val = "내려놓은 카드더미 위의 카드 색을 원하는 색으로 바꿉니다";
        break;
    }

    switch (name) {
      case "반사":
      case "점프":
      case "빅3":
        temp = "질문을 받았을 때 사용하는 특수카드";
        break;
      case "재활용":
      case "방향전환":
      case "색바꾸기":
        temp = "질문을 답한 뒤에 사용하는 특수카드";
        break;
    }

    if (color == "#FFFFFF") {
      val =
        "색상과 거리에 상관없이 무조건 낼 수 있으며, 거리 제한 없이 누구에게나 어떠한 질문도 할 수 있습니다.";
      temp = "빈 카드";
    }
    setDescription(val);
    setTitle(temp);
  }, [name]);

  const content = (
    <div className={styles.content}>
      <p>{title}</p>
      <p>{description}</p>
    </div>
  );
  return (
    <div
      className={state ? styles.currentcard : styles.card}
      style={{
        backgroundColor: color,
        color: fontColor ? fontColor : "black",
      }}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {select && (
        <>
          <div
            style={{
              position: "absolute",
              top: "-10px",
              left: "-10px",
              height: `${200}px`,
              width: `${150}px`,
              backgroundColor: "white",
              opacity: 0.8,
              borderRadius: "10px",
            }}
          ></div>
          <Button
            style={{
              position: "absolute",
              top: "-10px",
              left: "-10px",
              fontSize: "25px",
              height: `${200}px`,
              width: `${150}px`,
            }}
            icon={<CheckCircleFilled />}
            size="large"
            type="link"
            onClick={selectBtn}
          >
            선택하기
          </Button>
        </>
      )}
      {hover && mode != "intro" && (color == "#000000" || color == "#FFFFFF") && (
        <Popover content={content}>
          <Button
            style={{ position: "absolute", left: "0px" }}
            icon={<QuestionCircleTwoTone />}
            type="link"
            size="large"
          ></Button>
        </Popover>
      )}
      {distance < 5 ? <p>{distance}</p> : <p></p>}
      {Array.isArray(fontColor) ? (
        <div className={styles.names}>
          {fontColor.map((value, index) => {
            return <p style={{ color: value }}>{name[index]}</p>;
          })}
        </div>
      ) : (
        <div className={styles.name}>{name}</div>
      )}

      <div className={styles.img}>
        {name && <img src={"/icons/" + name.replace("/", ",") + ".png"} />}
      </div>
    </div>
  );
};

export default Card;
